import {
  Button,
  Container,
  createStyles,
  Divider,
  List,
  ListItem,
  ListItemText,
  makeStyles,
  Paper,
  Snackbar,
  TextField,
  Theme,
  Typography,
  useTheme,
} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import firebase from 'firebase';
import { Field, Form, Formik } from 'formik';
import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as yup from 'yup';
import Loading from '../../components/Loading';
import { getNotifications } from '../../store/actions/notification';
import { NotificationState } from '../../store/reducers/notification';
import { firestore } from './../../firebase/firebase';
import MaterialTable from 'material-table';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
    },
    subtitle: {
      marginTop: theme.spacing(2),
    },
    cardBackground: {
      backgroundColor: theme.palette.background.paper,
    },
  })
);

interface RootState {
  notification: NotificationState;
}

const Notification = () => {
  const notifications = useSelector(
    (state: RootState) => state.notification.notifications
  );

  const classes = useStyles();
  const theme = useTheme();
  const [isLoading, setIsLoading] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [error, setError] = useState(null);

  const dispatch = useDispatch();
  useEffect(() => {
    let subscribeNotifications: any;
    const fetchNotifications = async () => {
      subscribeNotifications = dispatch(getNotifications());
    };

    fetchNotifications();

    return () => subscribeNotifications();
  }, []);

  const getPageSize = (): number => {
    if (notifications.length < 5) {
      return 5;
    } else if (notifications.length < 10) {
      return 10;
    } else if (notifications.length < 15) {
      return 15;
    } else {
      return 20;
    }
  };

  return (
    <>
      <Paper className={classes.root}>
        <Container>
          <Formik
            initialValues={{
              title: '',
              message: '',
            }}
            validationSchema={yup.object({
              title: yup.string().required('This field cannot be empty'),
              message: yup.string().required('This field cannot be empty'),
            })}
            onSubmit={(values, { setSubmitting, resetForm }) => {
              setShowSnackbar(false);
              setError(null);
              setIsLoading(true);
              firestore
                .collection('notifications')
                .doc()
                .set({
                  title: values.title,
                  message: values.message,
                  timestamp: firebase.firestore.FieldValue.serverTimestamp(),
                })
                .then(() => {
                  setShowSnackbar(true);
                  setError(null);
                  resetForm({});
                  setIsLoading(false);
                })
                .catch((error) => {
                  setShowSnackbar(true);
                  setError(error.ErrorMessage);
                  setIsLoading(false);
                  console.error(error);
                });
            }}
          >
            {({ values, errors, isSubmitting }) => (
              <Form>
                <Typography
                  className={classes.subtitle}
                  variant="h6"
                  component="h6"
                >
                  Send Notification
                </Typography>

                <Field
                  error={errors.title}
                  helperText={errors.title}
                  name="title"
                  type="input"
                  as={TextField}
                  label="Title"
                  fullWidth
                  variant="outlined"
                  margin="dense"
                />

                <Field
                  error={errors.message}
                  helperText={errors.message}
                  name="message"
                  type="input"
                  as={TextField}
                  multiline
                  id="outlined-multiline-static"
                  label="Message"
                  fullWidth
                  rows={4}
                  variant="outlined"
                  margin="dense"
                />

                <Button
                  variant="contained"
                  type="submit"
                  color="primary"
                  style={{ marginTop: '16px' }}
                >
                  Submit
                </Button>
                {/* <pre>{JSON.stringify(values, null, 2)}</pre>
                <pre>{JSON.stringify(errors, null, 2)}</pre> */}
              </Form>
            )}
          </Formik>
        </Container>
      </Paper>

      <Paper className={classes.root} style={{ marginTop: theme.spacing(2) }}>
        <Container>
          <Typography className={classes.subtitle} variant="h6" component="h6">
            Notification Logs
          </Typography>
          <List dense>
            {notifications.map((notification, index) => {
              return (
                <Fragment key={notification.id}>
                  <ListItem>
                    <ListItemText
                      primary={
                        <>
                          <Typography variant="subtitle2" component="p">
                            {notification.title}
                          </Typography>
                          <Typography variant="body2" component="p">
                            {notification.message}
                          </Typography>
                        </>
                      }
                      secondary={notification.timestamp}
                    />
                  </ListItem>
                  {index !== notifications.length - 1 ? (
                    <Divider light />
                  ) : null}
                </Fragment>
              );
            })}
          </List>
        </Container>
      </Paper>

      {/* <MaterialTable
        style={{ marginTop: theme.spacing(2) }}
        key={notifications.length}
        options={{
          search: false,
          pageSize: getPageSize(),
          pageSizeOptions: [],
        }}
        columns={[
          { title: 'Message', field: 'formatMessage' }
        ]}
        data={notifications}
        title="Notification Logs"
      /> */}

      <Loading isLoading={isLoading} />

      <Snackbar
        open={showSnackbar}
        autoHideDuration={3000}
        onClose={() => setShowSnackbar(false)}
      >
        <Alert
          onClose={() => setShowSnackbar(false)}
          severity={error ? 'error' : 'success'}
        >
          {error ? error : 'Notification is created.'}
        </Alert>
      </Snackbar>
    </>
  );
};

export default Notification;
